// extracted by mini-css-extract-plugin
export default {"root":"NewsletterOptIn_root__HAOC-","finePrint":"NewsletterOptIn_finePrint__DhbRo marketplaceModalHelperLink"};